import PageTitle from "../../../../layout/PageTitle";
import React from "react";

const GrayPageTitle = props =>
    <PageTitle title={props.title} className="py-3 pl-4" labelClassName="font-weight-bold"/>;

export default GrayPageTitle;